<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === stripeSessionFilterKey.StripeSessionId) {
      <div class="px-4 py-2">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>ID de Session</mat-label>
          <input
            matInput
            [formField]="formTree.stripeSessionId"
            placeholder="Rechercher par ID de session..."
          />
        </mat-form-field>
      </div>
    }
  }
</form>
